var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinaNewConversation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60387 2.79199H2.68975C2.2416 2.79199 1.81181 2.97002 1.49492 3.28691C1.17803 3.6038 1 4.03359 1 4.48174V16.31C1 16.7581 1.17803 17.1879 1.49492 17.5048C1.81181 17.8217 2.2416 17.9997 2.68975 17.9997H14.518C14.9661 17.9997 15.3959 17.8217 15.7128 17.5048C16.0297 17.1879 16.2077 16.7581 16.2077 16.31V10.3959",
    stroke: "#676767",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9405 1.52494C15.2766 1.18883 15.7325 1 16.2078 1C16.6832 1 17.139 1.18883 17.4751 1.52494C17.8113 1.86105 18.0001 2.31692 18.0001 2.79225C18.0001 3.26758 17.8113 3.72345 17.4751 4.05956L9.44884 12.0859L6.06934 12.9307L6.91421 9.55125L14.9405 1.52494Z",
    stroke: "#676767",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinaNewConversation);
export default __webpack_public_path__ + "v10/media/bina-new-conversation.3321de9ee514eba974b4e0635d1952e8.svg";
export { ForwardRef as ReactComponent };